<template>
  <div class="grid-12 width-100 grid-column-gap-28 px-28 px-0-sm">
    <div v-for="(post, index) in posts" :key="post.node.id" class="span-4 pb-28">
      <div class="span-4">
        <div class="postContentColumn">
          <div class="postImageContainer">
            <button class="deletePostButton" @click="$emit('delete-post', post.node.id)">X</button>
            <img :src="getUrl(post.node.media.croppedUrl)" alt="" class="width-100" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "GridView",
  props: ["posts"],
  mounted() {
    this.$ma.trackEvent({
      action: "Posts dashboard View",
      properties: {
        "view type": this.$options.name,
      },
    });
  },
  methods: {
    getUrl(url) {
      return url.replace("q=90,", "q=90,w=270,");
    },
  },
};
</script>
<style lang="scss">
.sidebar-wrapper #sidebar ul {
  border-right: 1px solid black;
}

.postImageContainer {
  position: relative;
}

.deletePostButton {
  width: 32px;
  height: 32px;
  background: black;
  color: white;
  border: none;
  border-radius: 16px;
  cursor: pointer;
  position: absolute;
  z-index: 9;
  right: 4px;
  top: 4px;
}
</style>
